import { z } from "zod";
import { optional } from "./appointments";
import { recordId } from "./contracts";
import { actingOrganization, catalogMoney, parentService, serviceVendor } from "./services";

export const PROPERTY_PRICES_PER_WRITE_MAX = 500;

export const propertyPriceId = z.string().regex(/^\d+$/);

export const propertyPriceService = z.object({ id: recordId, name: z.string(), parent: parentService.nullable() });
export type PropertyPriceService = z.infer<typeof propertyPriceService>;

export const propertyPrice = z.object({
  id: propertyPriceId,
  vendor: serviceVendor,
  service: propertyPriceService,
  price: z.number(),
  pay: z.number().optional(),
});
export type PropertyPrice = z.infer<typeof propertyPrice>;

export const propertyPriceList = z.object({ items: z.array(propertyPrice) });
export type PropertyPriceList = z.infer<typeof propertyPriceList>;

export const propertyPriceQuery = z.object({ actingOrganization, vendor: optional(recordId.toLowerCase()) });
export type PropertyPriceQuery = z.infer<typeof propertyPriceQuery>;

export const propertyPriceSetting = z.object({ service: recordId.toLowerCase(), price: catalogMoney, pay: catalogMoney }).strict();
export type PropertyPriceSetting = z.infer<typeof propertyPriceSetting>;

export const propertyPricesRequest = z
  .object({ actingOrganization, prices: z.array(propertyPriceSetting).max(PROPERTY_PRICES_PER_WRITE_MAX) })
  .strict()
  .refine(({ prices }) => new Set(prices.map((setting) => setting.service)).size === prices.length, "name each service once");
export type PropertyPricesRequest = z.infer<typeof propertyPricesRequest>;

export const listedPriceQuery = z.object({ actingOrganization, service: recordId.toLowerCase() });
export type ListedPriceQuery = z.infer<typeof listedPriceQuery>;

export const listedFrom = z.enum(["propertyPrice", "catalog"]);
export type ListedFrom = z.infer<typeof listedFrom>;

export const listedServicePrice = z.object({
  service: recordId,
  price: z.number().nullable(),
  priceFrom: listedFrom.nullable(),
  pay: z.number(),
  payFrom: listedFrom.nullable(),
});
export type ListedServicePrice = z.infer<typeof listedServicePrice>;
